var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLifecycledesigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 166.46 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;}.cls-2{fill:#f5f5f5;}.cls-3{fill:url(#linear-gradient);}.cls-20,.cls-34,.cls-4{fill:#fff;}.cls-5{fill:#ff5252;}.cls-6{fill:#ff0;}.cls-7{fill:#69f0ae;}.cls-34,.cls-8{opacity:0.2;}.cls-10,.cls-9{fill:#6c63ff;}.cls-10,.cls-20{opacity:0.5;}.cls-10,.cls-20,.cls-34{isolation:isolate;}.cls-11{fill:url(#linear-gradient-2);}.cls-12{fill:url(#linear-gradient-3);}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-5);}.cls-15{fill:url(#linear-gradient-6);}.cls-16{fill:url(#linear-gradient-7);}.cls-17{fill:#ff9800;}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:url(#linear-gradient-9);}.cls-21{fill:url(#linear-gradient-10);}.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27{fill:none;stroke:#6c63ff;stroke-miterlimit:10;}.cls-23{stroke-dasharray:11.51 11.51;}.cls-24{stroke-dasharray:13.06 13.06;}.cls-25{stroke-dasharray:9.79 9.79;}.cls-26{stroke-dasharray:11.28 11.28;}.cls-27{stroke-dasharray:11.93 11.93;}.cls-28{fill:url(#linear-gradient-11);}.cls-29{fill:url(#linear-gradient-12);}.cls-30{fill:url(#linear-gradient-13);}.cls-31{fill:url(#linear-gradient-14);}.cls-32{fill:#ca7070;}.cls-33{fill:#00695c;}.cls-35{fill:#263238;}.cls-36{fill:url(#linear-gradient-15);}.cls-37{fill:url(#linear-gradient-16);}.cls-38{fill:#f6b9ad;}.cls-39{fill:#fccc63;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 80.45,
    y1: -6023.03,
    x2: 80.45,
    y2: -5840,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -5840)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 85.72,
    y1: -5980.48,
    x2: 85.72,
    y2: -5976.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 85.72,
    y1: -6001.57,
    x2: 85.72,
    y2: -5997.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 124.14,
    y1: -6001.57,
    x2: 124.14,
    y2: -5997.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 126.78,
    y1: -5871.26,
    x2: 126.78,
    y2: -5867.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 126.78,
    y1: -5876.91,
    x2: 126.78,
    y2: -5872.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 126.78,
    y1: -5882.56,
    x2: 126.78,
    y2: -5878.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 126.78,
    y1: -5888.21,
    x2: 126.78,
    y2: -5884.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 80.64,
    y1: -5965.04,
    x2: 80.64,
    y2: -5908.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 6.06,
    y1: -5399.7,
    x2: 6.06,
    y2: -5342.45,
    gradientTransform: "matrix(1, 0, 0, -1, 78.33, -5271.33)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 28.29,
    y1: -5356.76,
    x2: 28.29,
    y2: -5351.48,
    gradientTransform: "matrix(1, 0, 0, -1, 76.74, -5273.27)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 44.1,
    y1: -5355.26,
    x2: 44.1,
    y2: -5349.98,
    gradientTransform: "matrix(1, 0, 0, -1, 76.54, -5274.7)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 302.68,
    y1: -6054.6,
    x2: 302.68,
    y2: -6054.5,
    gradientTransform: "matrix(1, 0, 0, -1, -154.5, -5934.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 291.25,
    y1: -6117.81,
    x2: 291.25,
    y2: -6052.74,
    gradientTransform: "matrix(1, 0, 0, -1, -154.5, -5934.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 168.36,
    y1: -6058.33,
    x2: 168.36,
    y2: -6058.21,
    gradientTransform: "matrix(1, 0, 0, -1, -154.5, -5934.48)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 182.26,
    y1: -6132.33,
    x2: 182.26,
    y2: -6056.08,
    gradientTransform: "matrix(1, 0, 0, -1, -154.5, -5934.48)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1Asset 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 141.23,
    cy: 190.58,
    rx: 25.23,
    ry: 6.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 25.23,
    cy: 193.6,
    rx: 25.23,
    ry: 6.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.52,
    y: 1.51,
    width: 144.24,
    height: 5.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.88,
    width: 149.14,
    height: 183.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.52,
    y: 6.97,
    width: 144.24,
    height: 173.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 11.49,
    cy: 4.33,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 15.11,
    cy: 4.33,
    r: 1.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 18.74,
    cy: 4.33,
    r: 1.32
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 12.66,
    y: 13.56,
    width: 56.12,
    height: 3.39
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 52.58,
    y: 27.49,
    width: 56.12,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 12.66,
    y: 136.71,
    width: 56.12,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 76.31,
    y: 136.33,
    width: 18.83,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 76.31,
    y: 157.42,
    width: 18.83,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 114.72,
    y: 157.42,
    width: 18.83,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 77.06,
    y: 136.71,
    width: 17.7,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 77.06,
    y: 157.8,
    width: 17.7,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 115.1,
    y: 157.8,
    width: 17.7,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.66,
    y: 147.26,
    width: 56.12,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 77.06,
    y: 147.26,
    width: 56.12,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.06,
    y: 168.35,
    width: 56.12,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 12.66,
    y: 157.8,
    width: 56.12,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 12.66,
    y: 168.35,
    width: 56.12,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 52.58,
    y: 33.14,
    width: 31.64,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.87,
    y: 33.14,
    width: 10.92,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 52.58,
    y: 44.44,
    width: 31.64,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.87,
    y: 44.44,
    width: 10.92,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 52.58,
    y: 38.79,
    width: 56.12,
    height: 3.39
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 91.75,
    y: 13.56,
    width: 56.12,
    height: 3.39
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 123.39,
    y: 27.12,
    width: 6.78,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 123.39,
    y: 32.77,
    width: 6.78,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 123.39,
    y: 38.41,
    width: 6.78,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 123.76,
    y: 27.49,
    width: 6.03,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 123.76,
    y: 33.14,
    width: 6.03,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 123.76,
    y: 38.79,
    width: 6.03,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 123.39,
    y: 44.06,
    width: 6.78,
    height: 4.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 123.76,
    y: 44.44,
    width: 6.03,
    height: 3.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 11.53,
    y: 68.54,
    width: 138.22,
    height: 56.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 12.66,
    y: 69.67,
    width: 135.2,
    height: 53.48
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "16.8 73.82 147.87 73.82 147.87 69.67 12.66 69.67 12.66 123.15 16.8 123.15 16.8 73.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 14.54,
    y: 71.19,
    width: 139.35,
    height: 57.25,
    transform: "translate(-8.7 8.04) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 16.76,
    y: 72.68,
    width: 135.2,
    height: 53.48,
    transform: "translate(-8.66 8.06) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.67,122.62,22.33,93s12.05-12.8,36.38-3.31S94.51,92.43,98.47,86s24.48-13.56,31.13-2.84,14.63-1.33,14.63-1.33l2.7,29.63Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 36.92,
    y1: 86.49,
    x2: 37.12,
    y2: 88.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 37.52,
    y1: 93.06,
    x2: 39.68,
    y2: 116.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 39.88,
    y1: 118.97,
    x2: 40.08,
    y2: 121.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 60.08,
    y1: 90.17,
    x2: 60.28,
    y2: 92.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 60.73,
    y1: 97.32,
    x2: 62.29,
    y2: 114.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 62.51,
    y1: 116.9,
    x2: 62.72,
    y2: 119.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 83.71,
    y1: 94.19,
    x2: 83.93,
    y2: 96.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 84.3,
    y1: 100.11,
    x2: 85.57,
    y2: 112.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 85.75,
    y1: 114.79,
    x2: 85.98,
    y2: 117.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 104.94,
    y1: 80.91,
    x2: 105.15,
    y2: 83.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 105.53,
    y1: 87.39,
    x2: 107.65,
    y2: 110.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 107.84,
    y1: 112.78,
    x2: 108.05,
    y2: 115.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 120.27,
    y1: 77.8,
    x2: 120.47,
    y2: 80.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-27",
    x1: 120.88,
    y1: 84.53,
    x2: 123.12,
    y2: 109.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 123.33,
    y1: 111.37,
    x2: 123.53,
    y2: 113.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 36.85,
    cy: 86.35,
    r: 1.88,
    transform: "translate(-7.67 3.69) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 59.9,
    cy: 90.3,
    r: 1.88,
    transform: "matrix(1, -0.09, 0.09, 1, -7.94, 5.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 83.7,
    cy: 94.19,
    r: 1.88,
    transform: "translate(-8.19 7.97) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 104.8,
    cy: 80.92,
    r: 2.64,
    transform: "translate(-6.9 9.83) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 120.42,
    cy: 77.99,
    r: 2.64,
    transform: "translate(-6.57 11.24) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 104.8,
    cy: 80.92,
    r: 1.88,
    transform: "translate(-6.9 9.83) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 120.42,
    cy: 77.99,
    r: 1.88,
    transform: "matrix(1, -0.09, 0.09, 1, -6.57, 11.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 144.29,
    cy: 82.62,
    r: 1.88,
    transform: "translate(-6.89 13.42) rotate(-5.2)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M148.11,120l0,.09C148.42,120,148.11,120,148.11,120Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M145,183.3l6.13-1-.84-3.77h0v-.05h0l-4.35-20V144a5.39,5.39,0,0,0,0-.55c6.49-8.61,2.64-22.12,2.26-23.3l-.31.14a7.93,7.93,0,0,0-.3-1.56s-1.88-1.2-2.91.34a1.76,1.76,0,0,0,0,2.36l-.13,0a4.34,4.34,0,0,1,.6,1.48,3.25,3.25,0,0,0-.2-.38l-.38-.08,0,0-.13,0a8.6,8.6,0,0,1,.85,4.63,6.54,6.54,0,0,0-.75-.87A6.65,6.65,0,0,0,140,124.4h-.31a3.9,3.9,0,0,0-.51,0H139l-.21,0-.24,0-.18,0-.31.08-.11,0-.38.13a6.49,6.49,0,0,1-1.29.47.63.63,0,0,0-.18,0h0a2.15,2.15,0,0,1-1.41-.4l-.14-.11-.15-.14a1,1,0,0,0-.06.41,1.26,1.26,0,0,0,.44.86,1.2,1.2,0,0,0,.23.16,1,1,0,0,0,.4.11h.11l-.26.11h0l-.29.09h0a3.27,3.27,0,0,1-1.51,0h0l-.16,0-.24-.07.08.17,0,0,.07.11,0,.05.08.09,0,0,.09.09,0,0,.14.12,0,0,.1.07.07,0,.09.05.08,0,.09,0,.08,0,.11,0,.13,0,.1,0h.66a1.88,1.88,0,0,0,.57-.14l-.35.14h0l-.17.06-.18.06-.18.05-.18.05-.18,0-.19,0-.17,0-.2,0-.17,0-.21,0h-.9a1.59,1.59,0,0,1,.57.3,1.51,1.51,0,0,0,.35.19l.17,0h.84a2.46,2.46,0,0,1,1,.31,1.75,1.75,0,0,1,.42.38c-.05.09-.11.17-.15.26l-.12.23a4.67,4.67,0,0,0-.2.48,5.3,5.3,0,0,0-.32,1.83v.44a1.25,1.25,0,0,0,0,.27v.07q0,.17.06.33v.06q0,.14.07.27l0,.08a5.28,5.28,0,0,0,.23.63l0,.06.13.27v0l.17.3v0l.18.26,0,0a5.33,5.33,0,0,0,.44.53h0a5.32,5.32,0,0,0,1.42,1.07,2.39,2.39,0,0,0,0,.24h0a2.38,2.38,0,0,0,0,.26v2l-.33.19C133,137.16,125.92,122,125.92,122h-.17c.69-.51,0-2.74,0-2.74a3.22,3.22,0,0,0-1.32-.44h-.61l-.08,0h0l-.11,0h0l-.11,0,0,0-.07,0,0,.23-.07,0,0,0-.06.05,0,0-.06.06,0,0-.06.08,0,0-.09.13c-1,1.54,0,2.4,0,2.4a15.34,15.34,0,0,0-.09,1.79c-.08,11.09,11.8,19.69,12.41,20.12a22.78,22.78,0,0,0,0,14.5l0,.05a22.25,22.25,0,0,0-6.67,21l0,.23h.11a1.52,1.52,0,0,1,0,.15,1.73,1.73,0,0,1-.11.26,2,2,0,0,1-.28.4h0c-.12.14-.25.27-.4.41l-.15.14c-.6.57-1.21,1.13-.75,1.36h6.48v-2.83h.11s0-.09-.11-.26v0h0c-.34-.87-1.13-3.58.14-7.74,1.54-5.14,7.53-7.71,7.53-7.71l.11.38h0l4.7,15.44a.63.63,0,0,1,0,.18,2.52,2.52,0,0,1-.1.43,2.73,2.73,0,0,1-.13.32c-.29.6-.79,1.3-1,1.83a1.77,1.77,0,0,0-.08.22.69.69,0,0,0,0,.26.31.31,0,0,0,.2.25h.09l.18,0Zm-1.82-44-.38-.18v-1.87a2.38,2.38,0,0,0,0-.43,5.31,5.31,0,0,0,1.13-.73c-.23,1.15-.48,2.26-.71,3.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M122.73,123.76s-1.13-.95,0-2.66,3.23-.38,3.23-.38.75,2.47,0,3S122.73,123.76,122.73,123.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cbb1ca8a-3a06-4d8d-9881-c3637d2b9b50",
    className: "cls-33",
    d: "M134.47,187.28h-5.23a1.72,1.72,0,0,1-.49,1.34c-.7.81-2.12,1.8-1.45,2.13h7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M129.12,188.62a1.72,1.72,0,0,0,.49-1.34h-.38a1.72,1.72,0,0,1-.49,1.34c-.7.81-2.12,1.8-1.45,2.13h.38C127,190.42,128.42,189.44,129.12,188.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ec846da8-b8c9-4838-98ee-b96510078eab",
    className: "cls-33",
    d: "M153.09,186.2l-4.9.79a2.49,2.49,0,0,1-.22,1.72c-.53,1.13-1.74,2.54-1,2.84l7.09-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M150.71,121.44s5.6,17.67-3.79,27.45l-2.71-2.08s5.55-19.28,2.44-23.81C152.13,121.18,150.71,121.44,150.71,121.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M146.83,123s-1.13-.95,0-2.66,3.23-.38,3.23-.38.75,2.47,0,3S146.83,123,146.83,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M148.35,188.72a2.49,2.49,0,0,0,.22-1.73l4.52-.75v-.06l-4.9.81a2.49,2.49,0,0,1-.22,1.72c-.53,1.13-1.74,2.54-1,2.84l.3,0C146.72,191.14,147.84,189.79,148.35,188.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M142.18,137.9h0a2.66,2.66,0,0,1,2.66,2.66v2.56a2.66,2.66,0,0,1-2.66,2.66h0a2.66,2.66,0,0,1-2.66-2.66v-2.56A2.66,2.66,0,0,1,142.18,137.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M144.58,148s5.48-19,2.5-23.73l-.43-.09,0,0-.14,0c3.11,4.52-2.44,23.81-2.44,23.81l2.71,2.08.24-.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 142.28,
    cy: 134.77,
    r: 5.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M140.19,143.12v-2.56a2.64,2.64,0,0,1,.06-.56,5.88,5.88,0,0,1,2.36-11.11h-.33A5.88,5.88,0,0,0,139.58,140a2.64,2.64,0,0,0-.06.56v2.56a2.64,2.64,0,0,0,2.61,2.66l.38,0A2.67,2.67,0,0,1,140.19,143.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M148.26,164.09s-11.35,1.28-11.77,0a25.08,25.08,0,0,1,0-16.13,5.88,5.88,0,0,1,5.88-5.88h0a5.88,5.88,0,0,1,5.88,5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M148.26,164.09l5.13,23.53h-5.13l-5.31-17.46s-6.64,2.85-8.35,8.54,0,8.92,0,8.92h-5.51l-.06-.26a24.48,24.48,0,0,1,7.46-23.28h0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M137.15,164.09a25.08,25.08,0,0,1,0-16.13,5.88,5.88,0,0,1,5.5-5.87h-.38A5.88,5.88,0,0,0,136.4,148a25.09,25.09,0,0,0,0,16.13c.15.46,1.7.59,3.63.57C138.46,164.64,137.28,164.49,137.15,164.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M136.4,147.86s-15.18-10.63-13.66-24.1h3.42s8.16,17.67,13.38,19.36S136.4,147.86,136.4,147.86Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143,170.58l5.22,17.14H149l-5.31-17.46S143.45,170.36,143,170.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M137.25,164.18h-.75A24.48,24.48,0,0,0,129,187.46l.06.26h.75l-.06-.26A24.48,24.48,0,0,1,137.25,164.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M123.3,124h-.57c-1.51,13.48,13.66,24.1,13.66,24.1l.38-.14C135,146.61,121.88,136.53,123.3,124Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M137.59,132.14a9.74,9.74,0,0,1,.69,2.37,6.28,6.28,0,0,0,2.69,4.14,6,6,0,0,0,2.64.72,5,5,0,0,0,3.91-1.18,4.84,4.84,0,0,0,1.19-2.41,8.15,8.15,0,0,0-2.14-7.49,7.23,7.23,0,0,0-7.53-1.58,7.19,7.19,0,0,1-1.43.52,2.38,2.38,0,0,1-2.08-.69,1.31,1.31,0,0,0,1.27,1.7,3.66,3.66,0,0,1-2.81.15,2.38,2.38,0,0,0,3,1.2,8,8,0,0,1-3.39.69c.24,0,.72.45,1,.54a6.48,6.48,0,0,0,1.13.08A2.19,2.19,0,0,1,137.59,132.14Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.8,128.24a3.62,3.62,0,0,1-1.39.36,3.65,3.65,0,0,0,1.77-.36,1.33,1.33,0,0,1-1.34-1.32s0-.08,0-.11a2.24,2.24,0,0,1-.32-.27,1.31,1.31,0,0,0,1.27,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M138,127.25a7.2,7.2,0,0,0,1.43-.52,6.55,6.55,0,0,1,2.26-.46,6.61,6.61,0,0,0-2.64.46,7.2,7.2,0,0,1-1.43.52.63.63,0,0,0-.2,0A2.25,2.25,0,0,0,138,127.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M135,130.84c-.3-.09-.78-.53-1-.54a8,8,0,0,0,3.39-.69,2.1,2.1,0,0,1-.75.16,8,8,0,0,1-3,.53c.24,0,.72.45,1,.54a2.53,2.53,0,0,0,.79.06A1.65,1.65,0,0,1,135,130.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M144,139.38a6,6,0,0,1-2.64-.72,6.37,6.37,0,0,1-2.69-4.14,9.74,9.74,0,0,0-.69-2.37,2.19,2.19,0,0,0-1.86-1.22,3.78,3.78,0,0,0-.56,0h.18a2.19,2.19,0,0,1,1.86,1.22,9.73,9.73,0,0,1,.69,2.37,6.28,6.28,0,0,0,2.69,4.14,6,6,0,0,0,2.64.72H144Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.36,129.75a2.4,2.4,0,0,1-1.93-1.23,3.51,3.51,0,0,1-.44-.12A2.4,2.4,0,0,0,136.36,129.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M123.11,123.76s-1.13-.95,0-2.66a1.82,1.82,0,0,1,1.41-.86,1.85,1.85,0,0,0-1.79.86c-1.13,1.71,0,2.66,0,2.66A10.29,10.29,0,0,0,125,124,11.24,11.24,0,0,1,123.11,123.76Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M13.92,123.85l0-.1S13.57,123.67,13.92,123.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M49.41,130.16a2.48,2.48,0,0,0-.14-.35s0-.07-.06-.1l-.11-.2-.08-.1-.12-.15-.09-.09-.14-.11-.09-.07-.15-.09-.09,0-.17-.07-.09,0-.24-.07h0a3.89,3.89,0,0,0-1.65,0s-1.58,2.33-1,3.16l-.2-.06S33.3,144.92,26.68,147.35q-.25-.17-.52-.32v-2.45a2.89,2.89,0,0,0,0-.31h0a2.88,2.88,0,0,0,0-.29l0,0,.2-.11.28-.17.18-.12a3.76,3.76,0,0,0,.38-.29l.15-.13.26-.24.15-.15.3-.33.11-.13.26-.35.11-.16.21-.35.07-.12a5.17,5.17,0,0,0,.23-.48l.06-.15q.08-.2.15-.4a.7.7,0,0,1,0-.14c.05-.18.1-.35.14-.54a.22.22,0,0,1,0-.11q0-.23.07-.47v-.16c0-.19,0-.38,0-.58a6.4,6.4,0,0,0-1.42-4c.5-.78.83-1.25.83-1.25-.3-.21-.6-.4-.89-.58l-.29-.17c-.2-.12-.38-.23-.59-.34l-.33-.17-.52-.27-.34-.15-.5-.22-.33-.13-.49-.18-.31-.11-.5-.15-.27-.08-.56-.12-.2,0c-.25,0-.5-.08-.75-.1h0a8.93,8.93,0,0,0-4.52.69,8.34,8.34,0,0,1,1-4.2l-.15-.05-.05.05-.47.09a3.94,3.94,0,0,0-.24.46,5.24,5.24,0,0,1,.72-1.79l-.15-.05c.22-.23,1-1.22-.05-2.84-1.24-1.86-3.52-.41-3.52-.41a9.63,9.63,0,0,0-.35,1.88l-.38-.17a46.89,46.89,0,0,0-1.77,11.81C8,141.49,6.34,150.08,6,151.94H6l0,.15H6l0,.21,10.66.25v17L8.85,185.95s3,.09,7.4.66L15,195.39h0l-.41,2.46H22c.82-1.64-3.28-2.46-3.28-2.46h-.09l1.6-8.19,2.18.38a21.42,21.42,0,0,0,3.33.38h0a17.67,17.67,0,0,0,2.77-.12,19.27,19.27,0,0,1-.31,7.53h0l-.41,2.46h7.39c.72-1.43-2.31-2.24-3.1-2.42l0-.24a41.2,41.2,0,0,0,.29-8.36A10.12,10.12,0,0,0,35,185.23h0l.1-.09h0l0,0-5.5-15.44c1-4.37-2.55-9-.64-11.25s.75-5.22.53-5.72c5.17-2.26,15.61-7.91,18.54-17.7a18.5,18.5,0,0,0,.52-2.1S50.05,132.3,49.41,130.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M15.09,126.72s-5.6,17.67,3.79,27.45l2.71-2.08S16,132.8,19.15,128.28C13.67,126.45,15.09,126.72,15.09,126.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M19,128.27s1.13-.95,0-2.66-3.23-.38-3.23-.38-.75,2.47,0,3S19,128.27,19,128.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 20.96,
    y: 143.17,
    width: 5.31,
    height: 7.87,
    rx: 2.66,
    ry: 2.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M21.22,153.22s-5.48-19-2.5-23.73l.43-.09,0,0,.14,0c-3.11,4.52,2.44,23.81,2.44,23.81l-2.71,2.08-.24-.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 23.52,
    cy: 140.04,
    r: 5.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M25.61,148.39v-2.56a2.63,2.63,0,0,0-.06-.56,5.88,5.88,0,0,0-2.36-11.11h.33a5.88,5.88,0,0,1,2.69,11.11,2.64,2.64,0,0,1,.06.56v2.56a2.64,2.64,0,0,1-2.61,2.66l-.38,0A2.67,2.67,0,0,0,25.61,148.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M17.54,169.36s11.35,1.28,11.77,0c1.36-4.14-2.26-8.62-.45-10.81s.45-5.32.45-5.32a5.88,5.88,0,0,0-5.88-5.88h0a5.88,5.88,0,0,0-5.88,5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M28.87,158.55c1.88-2.26.45-5.32.45-5.32a5.88,5.88,0,0,0-5.88-5.88,2.5,2.5,0,0,0-.38,0,5.88,5.88,0,0,1,5.51,5.86s1.43,3.06-.45,5.32,1.81,6.66.45,10.81c-.13.4-1.3.55-2.85.57,1.92,0,3.46-.11,3.61-.57C30.69,165.21,27,160.74,28.87,158.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M26.9,169h0c4.14,5.87,6,14.74,4.79,23.28l0,.26H28.12s1.1-3.23,0-8.92a14.08,14.08,0,0,0-5.36-8.54l-3.41,17.46H16.05L19.35,169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M46.85,135.14s1.37-.57.78-2.54-3-1.31-3-1.31-1.45,2.14-.89,2.9S46.85,135.14,46.85,135.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M26.72,154.18s17.63-5.71,20.13-19l-3.27-1s-13,14.48-18.45,14.59S26.72,154.18,26.72,154.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M46.24,135.15l.55.17c-2.5,13.33-20.13,19-20.13,19l-.31-.24C28.43,153.39,43.92,147.59,46.24,135.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22,175.06l-3.41,17.46h.75l3.31-16.95A8.16,8.16,0,0,0,22,175.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.9,169h-.75c4.14,5.87,6,14.74,4.79,23.28l0,.26h.75l0-.26C32.88,183.73,31.05,174.86,26.9,169Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M46.48,135s1.37-.57.78-2.54a1.82,1.82,0,0,0-1.09-1.24,1.85,1.85,0,0,1,1.45,1.35c.59,2-.78,2.54-.78,2.54a10.29,10.29,0,0,1-2.21-.41A11.23,11.23,0,0,0,46.48,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M17.54,168.72l-7.16,15.06a88.51,88.51,0,0,1,12.43,1.51C30.72,186.8,34.49,183,34.49,183l-5.1-14.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M19.44,192.45s3.77.75,3,2.26H15.67l.38-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.49,192.45s3.77.75,3,2.26H27.73l.38-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M28.86,135.2s-9,12.8-4.9,18.08L7.77,152.9S12.29,123.91,28.86,135.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M28.86,135.2a13.72,13.72,0,0,0-6.31-2.57A15.94,15.94,0,0,1,27,134.83s-9,12.8-4.9,18.08l-14.25-.33-.06.33,16.19.38C19.82,148,28.86,135.2,28.86,135.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M29.41,168.72H28.28L33.38,183s-2.43,2.43-7.49,2.6c5.83.19,8.62-2.6,8.62-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M19.44,192.45h-.75s3.77.75,3,2.26h.75C23.21,193.2,19.44,192.45,19.44,192.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M31.49,192.45h-.75s3.77.75,3,2.26h.75C35.26,193.2,31.49,192.45,31.49,192.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifecycledesigner);
export default __webpack_public_path__ + "static/media/lifecycledesigner.16b01d3b56ba4dd20996cba723bfe170.svg";
export { ForwardRef as ReactComponent };